jQuery(document).ready(function () {

    var $ = jQuery.noConflict();

    let width = $('body').width();

    function accordion_footer(){
        if (width < 768){
            jQuery(".footerMenu__title").bind('click', function(){
                jQuery(".footerMenu__title").not(this).siblings('.footerMenu__menu').hide(300);
                jQuery(".footerMenu__title").not(this).removeClass('footerMenu__title--expanded');
                jQuery(this).siblings('.footerMenu__menu').toggle(300);
                jQuery(this).toggleClass('footerMenu__title--expanded');
            });
        }
    }

    accordion_footer();

    $(window).on('resize', function () {
        width = $('body').width();
        jQuery(".footerMenu__title").unbind('click');
        accordion_footer();
    });
});
